import { render, staticRenderFns } from "./EntryDetail.vue?vue&type=template&id=01e2d04f"
import script from "./EntryDetail.vue?vue&type=script&lang=js"
export * from "./EntryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports